module.exports = "/images/vendor/flag-icon-css/flags/1x1/nf.svg?801ee09f96411568a40a477ff99c348b";